import { globalRouteNames } from '../global-route-names';
import { Route } from '@angular/router';
import { User } from '../../models/user.model';
import { MpsRoleHelper } from '../../helpers/mps-role.helper';

export class PermissionHelper {

  static readonly routesRules: { routepath: string, allowedRoles?: string[], forbiddenRoles?: string[] }[] = [
    { routepath: globalRouteNames.home, allowedRoles: MpsRoleHelper.getAllRoleCodes() },
    { routepath: globalRouteNames.userManagement, allowedRoles: [MpsRoleHelper.ADMIN] },
    { routepath: globalRouteNames.admin, allowedRoles: [MpsRoleHelper.ADMIN] },
  ];

  static canUserActivate(user: User, route: Route) {
    const routeRule = this.routesRules.find(r => r.routepath === route.path);
    if (routeRule) {
      if (routeRule.forbiddenRoles) {
        return this.hasNotRole(user, routeRule.forbiddenRoles);
      }

      return this.hasAnyRole(user, routeRule.allowedRoles!);
    }
    return true;
  }

  static hasRole(user: User, roleCode: string): boolean {
    return (user.role !== null && user.role_id === MpsRoleHelper.getRoleIdFromCode(roleCode));
  }

  static hasAnyRole(user: User, rolesList: string[]) {
    return user.role && rolesList.includes(user.role.code.toUpperCase());
  }

  static hasNotRole(user: User, rolesList: string[]) {
    return user.role && !rolesList.includes(user.role.code.toUpperCase());
  }
}
